import React from "react";
import axios from 'axios';
import swal from 'sweetalert';
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";

import { checkingDriverStatus, setAadhaar, setAepsAmount, setAepsCashWithDrwalReq, setAepsMobile, setAepsRequest, setAepsResponse, setAepsSection, setAmount3, setBiometricDta, setBiometricDtaCaptureStatus, setCaptureUrl, setCurrentTimeStamp, setDeviceInfoUrl, setFullName, setMobile, setMoneyTransferSurChargeAmount3, setMoneyTransferTotalAmount3, setOrderId3, setReadyDeviceName, showCreateOrderResponse3, storeAepsReqBeforeBalanceEnuiry } from "../../redux/aeps/aeps.action";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import * as Spinner from 'react-spinkit';
import FooterComponet from "../FooterComponent/FooterComponet";
import tokenErrorHandler from "../tokenErrorHandler";
import biometryPaySprint from "./biometry-paysprint2";

const httpClient = axios.create();
class MerchantRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: '',
            amountErrrMsg: '',
            aePsActionType: '',
            aePsActionErrMsg: '',
            orderServiceErrMsg: '',
            deviceConnectStatus: '',
            mobile: '',
            mobileErrorMsg: '',
            aadhaar: '',
            adhaarErrMsg: '',
            searchableBankList: [],
            selectedBankName: '',
            selectedBankId: '',
            bankDetails: [],
            ifscCode: '',
            bankErrMsg: '',
            IIN: 607152,
            //merchant code for paysprint is acquireId
            // acquireId:1,-for yes bank

            acquireId: '',
            iinErr: '',
            progress: '',
            name: '',
            nameErr: '',
            emptyList: [],

            cashWithdrawlPricingValue: '',
            cashWithdrawlPricingErr: '',
            registered: false,
            authenticated: false,
            aepsEnabled: false,
            aepsFingerPrintCapturing: false,
            serviceMsg: ''
        }
    }



    componentDidMount() {

        store.dispatch(setCaptureUrl(''));
        store.dispatch(setDeviceInfoUrl(''));
        store.dispatch(setReadyDeviceName(''));
        store.dispatch(checkingDriverStatus(''));
        store.dispatch(setBiometricDta(''));

        store.dispatch(setFullName(''))
        store.dispatch(setAadhaar(''))
        store.dispatch(setMobile(''))
        store.dispatch(setCurrentTimeStamp(''))
        store.dispatch(setBiometricDtaCaptureStatus(''));


        this.setState({
            mobileErrorMsg: '',
            amountErrrMsg: '',
            adhaarErrMsg: '',
            aePsActionErrMsg: '',
            bankErrMsg: '',
            aadhaar: '',
        })

    }
    componentWillUnmount() {
    }


    enterMobile = (e) => {
        e.preventDefault();
        this.setState({
            mobileErrorMsg: '',
            mobile: e.target.value
        })
    }
    enterFullName = (e) => {
        e.preventDefault();
        this.setState({
            nameErr: '',
            name: e.target.value
        })
    }
    enterAadhaar = (e) => {
        e.preventDefault();
        this.setState({
            adhaarErrMsg: '',
            aadhaar: e.target.value
        })
    }

    enterIIN = (e) => {
        e.preventDefault();
        this.setState({
            IIN: e.target.value
        })
    }

    enterAcquireUd = (e) => {
        e.preventDefault();
        this.setState({
            acquireId: e.target.value
        })
    }



    captureFingerPrint = (event, status) => {

        event.preventDefault();
        this.setState({
            orderServiceErrMsg: ''
        })
      

        var validateAepsValue = this.validateBeforeAeps();
        if (validateAepsValue == true) {
            store.dispatch(setCaptureUrl(''))
            store.dispatch(setDeviceInfoUrl(''))
            store.dispatch(setReadyDeviceName(''))
            store.dispatch(checkingDriverStatus(''))

            store.dispatch(setBiometricDta(''));
            store.dispatch(setFullName(''))
            store.dispatch(setAadhaar(''))
            store.dispatch(setMobile(''))
            store.dispatch(setCurrentTimeStamp(''))
            store.dispatch(setBiometricDtaCaptureStatus(''));

            console.log('calling capturefingerprint');

            biometryPaySprint.captureFingerPrint(this.props.captureUrl, this.props.deviceInfoUrl, status);


        } 



    }




    validateBeforeAeps = () => {
        this.setState({
            mobileErrorMsg: '',
            adhaarErrMsg: '',
            nameErr: '',
            orderServiceErrMsg: ''
        })
        var nameValidation = false;
        var mobileValidation = false;
        var adhaarValidation = false;

        if (this.state.mobile == '' || this.state.mobile.length != 10) {
            this.setState({
                mobileErrorMsg: 'Please enter valid mobile No'
            })
        } else {
            mobileValidation = true;
        }



        if (this.state.aadhaar == '' ||
            (this.state.aadhaar.length != 12)) {
            this.setState({
                adhaarErrMsg: 'Please enter valid adhaarNo'
            })
        } else {
            adhaarValidation = true;
        }
        if (this.state.name == '') {
            this.setState({
                nameErr: 'Please enter name'
            })
        } else {
            nameValidation = true;
        }


        if (mobileValidation == true && adhaarValidation == true
            && nameValidation == true
            //  && bankValidation == true
        ) {
            return true
        } else {
            return false
        }
    }

    showAepsTxnHistory = (e) => {
        e.preventDefault();
        store.dispatch(setAepsSection('txnHistory'));
    }




    twoFactorRegister = (event) => {
        event.preventDefault();
        this.setState({
            progress: 'loading',
            orderServiceErrMsg: '',
            serviceMsg: ''
        })
        var cordinates = this.props.deviceInfo.location.coordinates;
        var latitude = '';
        var longitude = '';
        if (cordinates != null) {
            latitude = parseFloat(cordinates[0]).toFixed(2, 7);
            longitude = parseFloat(cordinates[1]).toFixed(2, 7);
        } else {
            latitude = 0.00;
            longitude = 0.00;
        }
        var btoaxmlDta = atob(this.props.aepsBiometricDta);

        var request = {
            "accessmodetype": "SITE",
            "adhaarnumber": this.state.aadhaar,
            "mobilenumber": this.state.mobile,
            "latitude": latitude,
            "longitude": longitude,
            "referenceNo": null,
            "submerchantid": this.props.agentInfo.id,
            "timestamp": moment().format("YYYY-MM-DD HH:mm:ss"),
            "data": btoaxmlDta,
            "ipaddress": this.props.deviceInfo.ip
        }



        
        var url = '/api/v1/paysprint/aeps/connector/two-factor-register';
        //need to add headers

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.post(url, request, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }).then((response) => {
            

            //rest logic
            if (response.data.response_code == 1) {
                if (response.data.data.includes("Merchant registered Successfully") ||
                    response.data.data.includes("Registration is already completed, Please perform Authentication")) {
                    store.dispatch(setBiometricDtaCaptureStatus('register-success'));
                    this.setState({
                        registered: true,
                        authenticated: false,
                        aepsEnabled: false,
                        serviceMsg: response.data.data
                    })

                } else if (response.data.errorcode == '2') {
                    store.dispatch(setBiometricDtaCaptureStatus('register-success'));
                    this.setState({
                        registered: true,
                        authenticated: false,
                        aepsEnabled: false,
                        serviceMsg: response.data.message
                    })
                } else if (response.data.errorcode == '0') {
                    store.dispatch(setBiometricDtaCaptureStatus('register-success'));
                    this.setState({
                        registered: true,
                        authenticated: false,
                        aepsEnabled: false,
                        serviceMsg: response.data.message
                    })
                }

            } else {
                if(response.data.response_code == null){
                    this.setState({
                        serviceMsg: response.data.message
                    })
                }else{
                    if (response.data.data != '') {
                        this.setState({
                            serviceMsg: response.data.data
                        })
    
                    } else if (response.data.message != '') {
                    
                        this.setState({
                            serviceMsg: response.data.message
                        })
                    }
                }
               
            }

            this.setState({
                progress: 'completed'
            })


        }).catch(error => {

            this.setState({
                progress: 'completed',
                orderServiceErrMsg:error.message
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }
        });

    }
    twoFactorAuthenticate = (event) => {
        event.preventDefault();
        this.setState({
            progress: 'loading',
            orderServiceErrMsg: '',
            serviceMsg: ''
        })
        var cordinates = this.props.deviceInfo.location.coordinates;
        var latitude = '';
        var longitude = '';
        if (cordinates != null) {
            latitude = parseFloat(cordinates[0]).toFixed(2, 7);
            longitude = parseFloat(cordinates[1]).toFixed(2, 7);
        } else {
            latitude = 0.00;
            longitude = 0.00;
        }
        var btoaxmlDta = atob(this.props.aepsBiometricDta);

        var request = {
            "accessmodetype": "SITE",
            "adhaarnumber": this.state.aadhaar,
            "mobilenumber": this.state.mobile,
            "latitude": latitude,
            "longitude": longitude,
            "referenceNo": null,
            "submerchantid": this.props.agentInfo.id,
            "timestamp": moment().format("YYYY-MM-DD HH:mm:ss"),
            "data": btoaxmlDta,
            "ipaddress": this.props.deviceInfo.ip
        }



        var url = 'api/v1/paysprint/aeps/connector/two-factor-authenticate';

        //need to add headers
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.post(url, request, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }).then((response) => {
        
            if (response.data.response_code == 1) {

                if (response.data.errorcode == '0') {
                    store.dispatch(setBiometricDtaCaptureStatus('auth-completed'));
                    this.setState({
                        registered: true,
                        authenticated: false,
                        aepsEnabled: false,
                        serviceMsg: response.data.message
                    })
                } else {
                    this.setState({
                        serviceMsg: response.data.message
                    })
                }


            } else {
                if(response.data.response_code == null){
                    this.setState({
                        serviceMsg: response.data.message
                    })
                }else{
                    if (response.data.data != '') {
                        this.setState({
                            serviceMsg: response.data.data
                        })
    
                    } else if (response.data.message != '') {
                    
                        this.setState({
                            serviceMsg: response.data.message
                        })
                    }
                }
               
            }

            this.setState({
                progress: 'completed'
            })


        }).catch(error => {

            this.setState({
                progress: 'completed',
                orderServiceErrMsg:error.message
            })
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }
        });

    }


    render() {

        return (
            <div class="col-12 col-lg-7 col-xl-8">
                <div class="card-b" id="rightdiv">
                    <div id="aepservices">
                        <div class="head">
                            <div class="hright">
                                <button class="close btn" data-toggle="tooltip" title="Close"
                                    onClick={this.showAepsTxnHistory}></button>
                            </div>
                            <Link to='/aeps-transfer'>
                                <button id='aepsTransfer' hidden={true}></button>
                            </Link>


                            <h3>Merchant Registration</h3>
                        </div>
                        <div class="reviewbox">
                            <form onSubmit={this.proceedToAeps}>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-floating mb-3 mt-3">
                                        </div>
                                    </div>
                                    {this.state.aePsActionErrMsg != '' &&
                                        <div class='valid-error'>
                                            {this.state.aePsActionErrMsg}
                                        </div>
                                    }

                                    <div class="col-12 col-sm-6">
                                        <div class="form-floating mb-3 mt-3">
                                            <input type="text" id="name" class="form-control"
                                                placeholder="Enter Name" name="name"
                                                onChange={this.enterFullName}
                                                readOnly={this.props.aepsBiometricDtaCaptureStatus == 'success' && true}
                                                required
                                            />
                                            <label for="name">Full Name</label>
                                        </div>
                                        {this.state.nameErr != '' &&
                                            <div class='valid-error'>
                                                {this.state.nameErr}
                                            </div>
                                        }
                                    </div>


                                    <div class="col-12 col-sm-6">
                                        <div class="form-floating mb-3 mt-3">
                                            <input type="number" id="mdn" class="form-control"
                                                placeholder="Enter mobile" name="mobile"
                                                value={this.state.mobile}
                                                onChange={this.enterMobile}
                                                onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                readOnly={this.props.aepsBiometricDtaCaptureStatus == 'success' && true}
                                                required />
                                            <label for="mdn">Mobile Number</label>
                                        </div>
                                        {this.state.mobileErrorMsg != '' &&
                                            <div class='valid-error'>
                                                {this.state.mobileErrorMsg}
                                            </div>
                                        }

                                    </div>

                                    <div class="col-12 col-sm-6">
                                        <div class="form-floating mb-3 mt-3">
                                            <input type="number" id="adhar" class="form-control"
                                                placeholder="Enter Aadhaar" name="Aadhaar"
                                                value={this.state.aadhaar}
                                                onChange={this.enterAadhaar}
                                                onInput={(e) => e.target.value = e.target.value.slice(0, 12)}
                                                readOnly={this.props.aepsBiometricDtaCaptureStatus == 'success' && true}
                                                required />
                                            <label for="adhar">Aadhaar Number</label>
                                        </div>
                                        {this.state.adhaarErrMsg != '' &&
                                            <div class='valid-error'>
                                                {this.state.adhaarErrMsg}
                                            </div>
                                        }
                                    </div>

                                    <div class="col-12 col-sm-6">


                                    </div>

                                    <div class="col-12 col-sm-6">

                                    </div>
                                    <div class="col-12 col-sm-6">

                                        <br />

                                    </div>


                                    <div class="w-100"></div>

                                    <div class="col-12 col-sm-6">
                                    
                                        {this.props.aepsBiometricDtaCaptureStatus == '' &&
                                            <button type="button" class="btn btn-primary" id="capturenow"
                                                onClick={e => this.captureFingerPrint(e, 'register-needed')}>Capture Fingerprint</button>
                                        }



                                        {this.props.aepsBiometricDtaCaptureStatus == 'register-needed' &&
                                            <div class='valid-success'>
                                                <button type="button" class="btn btn-primary" id="capturenow"
                                                    onClick={this.twoFactorRegister}
                                                    disabled={this.state.progress == 'loading' && true}
                                                >Check Registration</button>
                                            </div>}

                                        {this.props.aepsBiometricDtaCaptureStatus == 'register-success' &&
                                            <button type="button" class="btn btn-primary" id="capturenow"
                                                onClick={e => this.captureFingerPrint(e, 'auth-needed')}>Capture Fingerprint</button>
                                        }


                                        {this.props.aepsBiometricDtaCaptureStatus == 'auth-needed' &&
                                            <button type="button" class="btn btn-primary" id="capturenow"
                                                onClick={this.twoFactorAuthenticate}
                                                disabled={this.state.progress == 'loading' && true}
                                            >Check Authentication</button>
                                        }
                                        {this.state.progress == 'loading' &&
                                            <div class='valid-success'>
                                                Please wait...</div>}
                                        {this.state.serviceMsg != '' &&
                                            <div class='valid-success'>{
                                                this.state.serviceMsg
                                            }</div>}

                                        {this.state.orderServiceErrMsg != '' &&
                                            <div class='valid-error'>{
                                                this.state.orderServiceErrMsg
                                            }</div>}
                                    </div>





                                    {
                                        (this.props.checkingDriverStatus == 'READY' &&
                                            this.props.aepsBiometricDta != '' &&
                                            this.props.aepsBiometricDta != 'error') ?
                                            <div class="col-12 col-sm-6">
                                                <div class="device"><i class="connect"></i> Biometric device connected and fingerprint scanned for Aadhaar authentication</div>
                                            </div>
                                            :
                                            this.props.checkingDriverStatus == 'LOADING' ?
                                                <div class="col-12 col-sm-6">
                                                    <div class="device"><i class="connect"></i> Detecting Biometric Driver status..Please wait</div>
                                                </div>
                                                :
                                                this.props.checkingDriverStatus == 'ERROR' &&
                                                <div class="col-12 col-sm-6">
                                                    <div class="device"><i class="disconnect"></i> Biometric device not connected or Driver not installed!
                                                        Please make sure to connect device before go to AePS page</div>
                                                </div>

                                    }

                                </div>
                            </form>
                        </div>
                    </div>


                </div>


                {this.props.checkingDriverStatus == 'LOADING' &&
                    <div className="loader">
                        <div className="loader-content">
                            <Spinner name="ball-spin-fade-loader" />
                            <div className="loader-message"> Detecting Driver status..Please wait </div>
                        </div>
                    </div>
                }
            </div>

        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    aepsReduce: { aepsBiometricDtaCaptureStatus, aepsBiometricDta, checkingDriverStatus, deviceInfoUrl, captureUrl,
        aepsReqBeforeBalanceEnuiry },
    miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, deviceInfo, callBackUrl }
}
) => ({
    errorMessage, loginErrorMessage, aepsBiometricDtaCaptureStatus, aepsBiometricDta, checkingDriverStatus,
    deviceInfoUrl, captureUrl,
    aepsReqBeforeBalanceEnuiry,
    phone, agentInfo,
    token, clientRole, clientRequesterId, deviceInfo, callBackUrl
});




export default connect(mapStateToProps, null)(MerchantRegister);
